import { apiSlice } from './apiSlice';

export interface PlanetaryTransitFromMoon {
  sign: string;
  natalPlanets: string;
  houseNo: number;
  transitingPlanet: string;
  degree: string;
  nakshatra: string;
  pada: number;
  awastha: string;
  retro: boolean;
}

export interface PlanetaryTransitFromMoonResponse {
  data: PlanetaryTransitFromMoon[];
  date?: string;
  transit?: PlanetaryTransitFromMoon[];
  sign?:string;
}

export const planetaryTransitFromMoonApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetaryTransitFromMoon: builder.query<
      PlanetaryTransitFromMoonResponse,
      { userId: string; rashi: string }
    >({
      query: ({ userId, rashi }) => ({
        url: '/astrology/transite',
        method: 'GET',
        params: {
          userId,
          rashi,
        },
      }),
    }),
  }),
});

export const { useGetPlanetaryTransitFromMoonQuery } = planetaryTransitFromMoonApi;
